import React, { Component, Children } from 'react';
import { debounce } from 'helpers/decorators';

import { FormField } from './form-field';
import Button from 'ui/button';
import ObjectField from './object-field';

import { FormProps } from 'ui/form/fields';

interface FormState {}

export default class Form extends Component<FormProps, FormState> {
  static getDerivedStateFromProps({ formData }, { prevFormData }) {
    if (formData !== prevFormData) {
      return {
        prevFormData: formData,
        formData
      };
    }

    return null;
  }

  static getErrors(formRef, formData) {
    if (formRef && formRef.formObject) {
      const errors = ObjectField.getErrors(formRef.formObject.props, { root: formData });

      return !errors;
    }

    return 'No form to validate';
  }

  fields: { [string]: FormField } = {};
  formObject: ObjectField;
  mounted: boolean = true;
  state = { formData: {} };
  touched: { [string]: boolean } = {};
  /**
   * Holds a timeout for validating the form after blur, if form gets focus again it is cleared
   */
  validationTimeout: false | number = false;

  componentWillUnmount() {
    if (this.mounted) {
      this.performChange(this.state.formData);
      this.mounted = false; // I dub thee in the name of redundancy!!!!!
    }
  }

  validate(onlyTouched: boolean): boolean {
    return this.formObject ? this.formObject.validate(onlyTouched) : true;
  }

  handleBlur = () => {
    this.validationTimeout = setTimeout(this.handleValidate, 100);
  };

  handleCancel = e => {
    e.preventDefault();
    const { onCancel } = this.props;

    if (onCancel) onCancel();
  };

  handleChange = formData => {
    this.setState({ formData });
    this.doChange(formData);
  };

  handleError = value => {
    console.log('Error:', value);
  };

  handleFocus = () => {
    if (this.validationTimeout) clearTimeout(this.validationTimeout);
  };

  handleSubmit = e => {
    e.preventDefault();
    const { noValidation, onSubmit } = this.props;
    if ((noValidation || this.validate(false)) && onSubmit) onSubmit(this.state.formData);
  };

  handleValidate = () => {
    this.validate(false);
  };

  @debounce(400)
  doChange(formData) {
    this.performChange(formData);
  }

  performChange(formData) {
    if (this.mounted) {
      const { noValidation, onChange } = this.props;
      let isValid = true;
      if (this.formObject) isValid = Form.getErrors(this.formObject, formData);

      if ((noValidation || isValid) && onChange) {
        onChange(formData);
      }
      if (!noValidation) this.setState({ error: !isValid });
    }
  }

  render() {
    const {
      className,
      cancelLabel,
      children,
      noButtons,
      noValidation,
      submitLabel,
      style,
      tiny
    } = this.props;
    const { formData } = this.state;

    return (
      <form
        className={className}
        onBlur={this.handleBlur}
        onFocus={this.handleFocus}
        onReset={this.handleCancel}
        onSubmit={this.handleSubmit}
        style={{ minWidth: 320, ...style }}
      >
        <ObjectField
          formData={formData}
          onChange={this.handleChange}
          name="root"
          noValidation={noValidation}
          ref={ref => (this.formObject = ref)}
          tiny={tiny}
          value={formData}
        >
          {children}
        </ObjectField>

        {!noButtons && (
          <React.Fragment>
            <Button
              // disabled={!!this.state.error}
              flat={submitLabel || 'Submit'}
              role={'formbutton'}
              style={{ marginRight: 10 }}
              type="submit"
              warning={this.state.error}
            />
            <Button
              // disabled
              flat={cancelLabel || 'Cancel'}
              role={'formbutton'}
              type="reset"
              warning={this.state.error}
            />
          </React.Fragment>
        )}
      </form>
    );
  }
}
